/**
 * CATMAN-S38 — Precondiciones del autoguardado del editor de planogramas.
 *
 * Separa "no había nada que hacer" de "falló el guardado": sólo el POST fallido debe pintar
 * AUTOSAVE_STATUS_ERROR. El resto de los casos se cancelan en silencio y se reintentan en el próximo tick.
 */
export type AutosaveAttemptDecision =
  /** Hay cambios guardables y el canal está libre. */
  | 'proceed'
  /** El planograma todavía no existe en el backend (nunca se guardó una vez). */
  | 'no-entity'
  /** Ya hay un guardado o una carga en curso: no se mandan POSTs concurrentes. */
  | 'busy'
  /** El estado es idéntico al original: no hay nada que guardar. */
  | 'no-changes';

export interface AutosaveAttemptInput {
  planogramId?: number | null;
  inSave?: boolean;
  inLoad?: boolean;
  /** Se evalúa sólo si el resto de las precondiciones pasa (la comparación no es gratis). */
  hasChanges: () => boolean;
}

export function resolveAutosaveAttempt(input: AutosaveAttemptInput): AutosaveAttemptDecision {
  const id = Number(input?.planogramId);
  if (!Number.isFinite(id) || id <= 0) return 'no-entity';

  if (input.inSave === true || input.inLoad === true) return 'busy';

  if (input.hasChanges() !== true) return 'no-changes';

  return 'proceed';
}
